import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { environment } from 'environments/environment';
import { SharedService } from 'app/services/shared.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    nav: boolean = false;
    user: User;
    userImage: string = 'assets/images/avatars/usuario.png';
    currentLang: string;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    mostrarAlertaInternet: boolean = false;
    entorno: string = "Test-Pruebas";

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _userService: UserService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        public _shared: SharedService,
        private _changeDetectorRef: ChangeDetectorRef,
        private translate: TranslateService,
    ) {}

    get currentYear(): number {
        return new Date().getFullYear();
    }

    ngOnInit(): void {
        this.initializeLanguage();

        this._navigationService
            .get()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                // Usamos un tiempo mínimo para asegurar el registro en el Service
                setTimeout(() => {
                    this.navigation = navigation;
                    // Forzamos la detección de cambios para que el *ngIf del HTML reaccione
                    this._changeDetectorRef.markForCheck();
                }, 50);
            });

        // Suscribirse al servicio de usuario
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });

        // Suscribirse a cambios de pantalla (Media watcher)
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    /**
     * Alternar navegación
     */
    toggleNavigation(name: string): void {
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name,
            );

        if (navigation) {
            // Alternar estado
            navigation.toggle();

            // Actualizar estado local para clases CSS
            this.nav = navigation.opened;
        }
    }

    cerrarAlerta() {
        this.mostrarAlertaInternet = false;
    }

    initializeLanguage() {
        // 1. Intentar obtener el idioma guardado
        const savedLang = localStorage.getItem('lang');
        this.translate.setDefaultLang('es'); // Establecer 'es' como idioma principal

        let finalLang: string;

        if (savedLang) {
            // Caso 1: Usar el idioma guardado
            finalLang = savedLang;
        } else {
            // Caso 2: Usar el idioma del navegador si es 'es' o 'en'
            const browserLang = this.translate.getBrowserLang();
            finalLang =
                browserLang && browserLang.match(/es|en/) ? browserLang : 'es';
        }

        this.translate.use(finalLang);
        this.currentLang = finalLang; // Sincroniza la variable con el idioma usado
    }
}
